<script setup lang="ts">
import { getSkillNameById, skillCollection } from '@/core/skill'
import { useUserStore } from '@/stores/modules/user'

const userStore = useUserStore()

const props = defineProps<{ mp: number; cdList: [number, number][] }>()

const clampPercentage = (value: number) => {
  if (!Number.isFinite(value)) {
    return 0
  }
  return Math.min(Math.max(value, 0), 100)
}

const getSkillPercentage = (skillId: number, cd: number) => {
  const totalCd = skillCollection[skillId]?.cd || 0
  if (totalCd <= 0) {
    return 0
  }
  return clampPercentage(100 - (cd / totalCd) * 100)
}

const getMpPercentage = () => {
  const maxMp = userStore.userAttr.mp || 0
  if (maxMp <= 0) {
    return 0
  }
  return clampPercentage((props.mp / maxMp) * 100)
}
</script>

<template>
  <div class="skill-info">
    <div class="cd-list">
      <div class="item" v-for="[skillId, cd] of props.cdList" :key="skillId">
        <el-progress
          v-if="skillId"
          type="dashboard"
          :percentage="getSkillPercentage(skillId, cd)"
          :width="60"
          :color="[
            { color: '#ff6b6b', percentage: 20 },
            { color: '#f8a458', percentage: 40 },
            { color: '#e0d74c', percentage: 60 },
            { color: '#71dd8a', percentage: 80 },
            { color: '#1abc9c', percentage: 100 },
          ]"
        >
          <span>{{ getSkillNameById(skillId, true) }}</span>
        </el-progress>
      </div>
    </div>
    <div class="mp">
      <span>魔法值：</span>
      <div class="progress-wrap" style="width: 80%">
        <el-progress :percentage="getMpPercentage()" :text-inside="true" :stroke-width="16">
          <span>{{ props.mp }} / {{ userStore.userAttr.mp }}</span>
        </el-progress>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.skill-info {
  padding-bottom: 10px;
  .cd-list {
    padding: 0 10px;
    display: flex;
    flex-flow: row nowrap;
    .item:nth-child(n + 1) {
      margin-left: 10px;
    }
  }
  .mp {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }
}
</style>
